import { Helmet } from 'react-helmet-async';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'http://localhost:3000';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const Seo = ({
    title,
    description,
    path = '/',
    type = 'website',
    image = DEFAULT_IMAGE,
    noindex = false,
}) => {
    const canonical = `${SITE_URL}${path}`;
    const isDev = process.env.NODE_ENV === 'development';

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={canonical} />

            {(noindex || isDev) && (
                <meta name="robots" content="noindex,nofollow" />
            )}

            <meta property="og:type" content={type} />
            <meta property="og:site_name" content="RUZY" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};

export default Seo;